
import React from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import { AnimatedSection } from '@/hooks/useScrollAnimation';

const estruturaImages = [
  { src: '/estrutura/estrutura-1.webp', alt: 'Dr. Luis Brunello sentado à mesa do consultório' },
  { src: '/estrutura/estrutura-2.webp', alt: 'Sala de consulta com mesa de mármore, estante iluminada e divisória de vidro canelado' },
  { src: '/estrutura/estrutura-3.webp', alt: 'Corredor da clínica com revestimento de madeira e iluminação indireta' },
  { src: '/estrutura/estrutura-4.webp', alt: 'Recepção da Cirurgicare com o logotipo na parede de mármore' },
  { src: '/estrutura/estrutura-5.webp', alt: 'Entrada da clínica Cirurgicare, loja 3001-B' },
  { src: '/estrutura/estrutura-6.webp', alt: 'Consultório com estante de madeira iluminada, mesa de mármore e computador' },
  { src: '/estrutura/estrutura-7.webp', alt: 'Balcão de recepção em mármore com o letreiro da Cirurgicare' },
  { src: '/estrutura/estrutura-8.webp', alt: 'Consultório com prateleiras iluminadas, mesa oval e televisão na parede' },
];

const StructureSection: React.FC = () => {
  return (
    <section id="estrutura" aria-labelledby="structure-title" className="pt-8 md:pt-12 pb-16 md:pb-24 bg-dark-base relative overflow-hidden">
      <div className="absolute top-0 left-1/3 w-[400px] h-[400px] decorative-blur decorative-blur-primary opacity-10 pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <AnimatedSection>
          <header className="text-center mb-8 md:mb-10">
            <p className="subtitle-wide text-gold mb-3 block">Infraestrutura</p>
            <h2 id="structure-title" className="text-3xl md:text-4xl text-light-primary tracking-tight leading-tight">
              Conheça nossa estrutura cirúrgica
            </h2>
            <p className="text-light-muted text-base mt-3 max-w-2xl mx-auto leading-relaxed">
              Ambiente planejado com tecnologia de ponta, segurança e conforto para cada etapa do seu procedimento.
            </p>
          </header>
        </AnimatedSection>

        <AnimatedSection delay={150}>
          <div className="max-w-7xl mx-auto relative">
            <Carousel opts={{ align: 'start', loop: true }} className="w-full">
              <CarouselContent className="-ml-4">
                {estruturaImages.map((img, index) => (
                  <CarouselItem
                    key={index}
                    className="pl-4 basis-full sm:basis-1/2 lg:basis-1/3 xl:basis-1/4"
                  >
                    <figure className="overflow-hidden rounded-xl aspect-[4/3] m-0">
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                        loading="lazy"
                        decoding="async"
                        width="480"
                        height="360"
                      />
                    </figure>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="carousel-arrow -left-5" />
              <CarouselNext className="carousel-arrow -right-5" />
            </Carousel>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default StructureSection;
